export default __webpack_public_path__ + "static/Start-project-with-us-bd1849181b103ec58d54dc27635064f2.png";